//src/utils/axios.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '${process.env.REACT_APP_API_URL}',
  withCredentials: true,
  timeout: 180000, 
  maxContentLength: 3 * 1024 * 1024,
  maxBodyLength: 3 * 1024 * 1024
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Production-д debug хаах бол:
    if (process.env.NODE_ENV === 'development') {
      console.log('🌐 Request:', config.method?.toUpperCase(), config.url);
    }
    return config;
  },
  (error) => {
    console.error('❌ Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('✅ Response:', response.status, response.config.url);
    }
    return response;
  },
  (error) => {
    console.error('❌ Response Error:', error.response?.status, error.message);
    
    if (error.response?.status === 401) {
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;